import { FIELD_EDITOR_SELECTS } from "#/admin/legacy/form-builder/field-editor-selects.js";
import { getQuillHTML, setQuillHTML } from "#/shared/lib/quill-html";

// Returns undefined when the field's editor has not been built. The form saves from the editor's
// `input` event, which reaches it before Quill has read the keystroke into its document, so the
// editor catches up first.
function wysiwygFieldHTML($field) {
  const editor = Quill.find($field.find(".editor").get(0));
  if (!editor) {
    return undefined;
  }

  editor.update();
  return getQuillHTML(editor);
}

class FormBuilderFieldEditor {
  constructor(formTemplate, formData, baseTypes, container) {
    this.container = jQuery(container);
    this.formTemplate = formTemplate;
    this.formData = formData;
    this.baseTypes = baseTypes;

    // BEHAVIOUR

    this.container.on("click", ".btn-tool-back", (e) => {
      this.hideFieldEditor(e);
    });
    // FIXME: listening for the input event is relying on the fact that Quill uses contenteditable.
    // We should not need to know the inner workings of Quill, or assume that Quill will never change the way it makes editable content.
    // I will fix with PR: https://github.com/combinaut/sparkle/pull/11309
    this.container.on("input", '[data-wysiwyg="true"]', (e) => {
      this.saveFieldHandler(e);
    });
    this.container.on("input", "input", (e) => {
      this.saveFieldHandler(e);
    });
    this.container.on("input", "textarea", (e) => {
      this.saveFieldHandler(e);
    });
    this.container.on("change", FIELD_EDITOR_SELECTS, (e) => {
      this.saveFieldHandler(e);
    });
    this.container.on("click", ".btn-tool-add-option", (e) => {
      this.addFieldOptionHandler(e);
    });
    this.container.on("click", ".btn-tool-delete-option", (e) => {
      this.removeFieldOptionHandler(e);
    });
    this.container.on("click", ".btn-tool-delete", (e) => {
      this.deleteFieldHandler(e);
    });
  }

  // EVENT HANDLERS

  saveFieldHandler(e) {
    e.preventDefault();
    this.container.trigger("FB:saveFieldHandler");
  }

  deleteFieldHandler(e) {
    e.preventDefault();
    this.container.trigger("FB:deleteField", [this.currentField]);
  }

  hideFieldEditor(e) {
    e.preventDefault();
    this.container.trigger("FB:hideFieldEditor");
  }

  // HELPER FUNCTIONS

  addFieldOptionHandler(e) {
    e.preventDefault();
    var formOptionContainer = this.container.find(".form-field-option");
    var $original = this.container.find(".form-field-option").first(),
      $clone = $original.clone();

    $clone.find("input").val("");
    $clone.find("[data-wysiwyg=true]").empty();
    formOptionContainer.last().after($clone);
    this.initWYSIWYGEditFields();
  }

  removeFieldOptionHandler(e) {
    e.preventDefault();

    // Do not allow deletion of the last option
    if (this.container.find(".form-field-option").length <= 1) {
      return;
    }

    jQuery(e.target).closest(".form-field-option").remove();

    this.container.trigger("FB:saveFieldHandler");
  }

  addNewTemplate(field, template, type) {
    this.container.html(
      Sparkle.HandlebarsTemplates["form-builder-field-editor"]({
        field: field,
        template: template,
        type: type,
        selectItems: template.select_items || {},
      }),
    );
  }

  show(field, submit) {
    this.currentField = jQuery(field);
    var fieldData;
    var attributes;

    var fieldsData = this.formData.fields;
    var fieldAttributes = this.formTemplate.fieldAttributes;

    if (submit) {
      fieldData = fieldAttributes.submit;
      attributes = fieldAttributes.submit;
    } else {
      fieldData = fieldsData[this.currentField.index()];
      attributes = fieldAttributes[fieldData.type];
    }

    this.currentField.addClass("selected");
    this.addNewTemplate(fieldData, attributes, this.baseTypes[fieldData.type]);
    this.initWYSIWYGEditFields();
  }

  hide() {
    this.container.empty();
    this.currentField = null;
  }

  initWYSIWYGEditFields() {
    this.container.find("[data-wysiwyg=true]").each(function () {
      if (jQuery(this).data("loaded")) {
        return;
      }

      var $editorTemplate = jQuery(Sparkle.Components.Wysiwyg.render("extended"));
      var content = jQuery(this).html();
      jQuery(this).html($editorTemplate);

      var editor = Sparkle.Components.Wysiwyg.initialize(jQuery(this).find(".editor").get(0));
      setQuillHTML(editor, content);

      jQuery(this).data("loaded", true);
    });
  }

  setBaseTypes(baseTypes) {
    this.baseTypes = baseTypes;
  }

  // Persisting

  persistAllFields(fieldData) {
    this.persistText(fieldData);
    this.persistBoolean(fieldData);
    this.persistWYSIWYG(fieldData);
    this.persistMultiType(fieldData);
    this.persistNested(fieldData);
  }

  persistText(fieldData) {
    this.container.find("[data-field-text-attribute]").each((i, value) => {
      var $input = jQuery(value);
      if ($input.data("field-text-attribute") === "submit") {
        this.formData.submit_text = $input.val();
      } else {
        fieldData[$input.data("field-text-attribute")] = $input.val() || "";
      }
    });
  }

  persistBoolean(fieldData) {
    this.container.find("[data-field-boolean-attribute]").each(function () {
      var $input = jQuery(this);
      fieldData[$input.data("field-boolean-attribute")] = $input.is(":checked");
    });
  }

  persistWYSIWYG(fieldData) {
    this.container.find("[data-field-wysiwyg-attribute]").each(function () {
      var $input = jQuery(this);
      fieldData[$input.data("field-wysiwyg-attribute")] = wysiwygFieldHTML($input);
    });
  }

  persistMultiType(fieldData) {
    this.container.find("[data-field-multiple-attribute]").each(function () {
      var $input = jQuery(this);
      var target = fieldData[$input.data("field-multiple-attribute")];

      $input.find("input").each(function (index) {
        var existingValue = target[index];
        var newValue = jQuery(this).val();

        // If the existing value is an object, store the value under a value key so we don't erase the existing config
        // This allows fields like `static_options` to provide configuration attributes for the field, and have the value
        // stored as a value attribute.
        if (jQuery.isPlainObject(existingValue)) {
          existingValue["value"] = newValue;
        } else {
          target[index] = newValue;
        }
      });
    });
  }

  persistNested(fieldData) {
    this.container.find("[data-field-multiple-nested-attribute]").each(function () {
      var $input = jQuery(this);

      var values = $input
        .find("[data-field-attribute-container]")
        .map(function () {
          var inputValues = {};

          jQuery(this)
            .find("[data-field-attribute-input]")
            .each(function () {
              var value;

              if (jQuery(this).data("wysiwyg")) {
                value = wysiwygFieldHTML(jQuery(this));
              } else {
                value = jQuery(this).val();
              }

              inputValues[jQuery(this).data("field-attribute-input")] = value;
            });

          return inputValues;
        })
        .get();
      fieldData[$input.data("field-multiple-nested-attribute")] = values;
    });
  }
}

window.FormBuilderFieldEditor = FormBuilderFieldEditor;
